import API from "Api";
import { CREATE_SIMULATOR_ENDPOINT } from "./endpoints";

// Create simulator
export const createSimulatorAPI = (payload) => {
  return API.post(CREATE_SIMULATOR_ENDPOINT, payload);
};
